import type { RaspadinhaPrizeReceiptSignature, RaspadinhaTimeSlotWinner } from '@/types/raspadinha-campaign'

function buildDeterministicHash(seed: string): string {
  const segments: string[] = []
  let state = seed.split('').reduce((accumulator, char) => {
    return (Math.imul(31, accumulator) + char.charCodeAt(0)) >>> 0
  }, 0x811c9dc5)

  for (let index = 0; index < 8; index += 1) {
    state ^= seed.charCodeAt(index % seed.length)
    state = Math.imul(state, 0x01000193) >>> 0
    segments.push(state.toString(16).padStart(8, '0'))
  }

  return segments.join('')
}

function buildDeterministicIp(seed: string): string {
  const base = seed.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0)
  const second = (base % 200) + 20
  const third = (base % 180) + 10
  const fourth = (base % 220) + 5
  return `189.${second}.${third}.${fourth}`
}

function buildDeterministicSignedAt(seed: string): string {
  const base = seed.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0)
  const day = (base % 27) + 1
  const month = (base % 12)
  const hour = (base % 14) + 8
  const minute = base % 60
  const second = (base * 7) % 60

  const date = new Date(Date.UTC(2026, month, day, hour, minute, second))
  return date.toISOString()
}

export function createMockPrizeReceiptSignature(
  winnerId: string
): RaspadinhaPrizeReceiptSignature {
  return {
    hash: buildDeterministicHash(`receipt:${winnerId}`),
    ip_address: buildDeterministicIp(winnerId),
    signed_at: buildDeterministicSignedAt(winnerId),
  }
}

export function getWinnerPrizeReceiptSignature(
  winner: RaspadinhaTimeSlotWinner
): RaspadinhaPrizeReceiptSignature {
  if (winner.receipt_signature) {
    return winner.receipt_signature
  }

  return createMockPrizeReceiptSignature(winner.id)
}

export function formatReceiptSignedAt(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'

  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(date)
}
